import { render, staticRenderFns } from "./liveDetail.vue?vue&type=template&id=085ca478&scoped=true"
import script from "./liveDetail.vue?vue&type=script&lang=js"
export * from "./liveDetail.vue?vue&type=script&lang=js"
import style0 from "./liveDetail.vue?vue&type=style&index=0&id=085ca478&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ca478",
  null
  
)

export default component.exports